import {
  type StepsDefinition,
  type DomAnimationHelper,
  type AnimationHelperAwaiter,
  type DomAnimationHelperOptions,
} from "./useDomAnimationHelper.types.js";
import {
  OnImmediate,
  onElementAnimated,
  OnAnimationFrame,
} from "./useDomAnimationHelper.awaiter.js";
import {
  getStepsNormalizer,
  processAnimationSteps,
  type InternalState,
} from "./useDomAnimationHelper.utils.js";

/*                       */
export * from "./useDomAnimationHelper.awaiter.js";
export * from "./useDomAnimationHelper.types.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useDomAnimationHelper = <Steps extends StepsDefinition>(
  stepsDefinition: Steps,
  options: DomAnimationHelperOptions = {},
): DomAnimationHelper<Steps> => {
  const { initial = false } = options;

  /*                                             */
  /*                                                                    */
  const state = $state<InternalState>({
    $animIn: false,
    $animOut: false,
    $target: false,
    $direction: undefined,
  });

  /*                                  */
  const toggle = processAnimationSteps.bind(
    state,
    /*                                       */
    /*                                           */
    Object.keys(stepsDefinition).map((step) => ((state[step] = initial), step)),

    /*                                       */
    getStepsNormalizer(stepsDefinition),
  );

  /*                                                   */
  return [state as never, toggle, toggle.bind(null, true), toggle.bind(null, false)];
};

/**
 *
 *
 *
 *
 *
 *
 */
export const useSimpleDomAnimationHelper = (
  getAnimatedElements: () => Element[] | HTMLCollection | null | undefined,
  getAnimationsOptions?: Parameters<HTMLElement["getAnimations"]>[0],
): DomAnimationHelper<{
  active: [AnimationHelperAwaiter, AnimationHelperAwaiter];
  ready: AnimationHelperAwaiter;
  done: [AnimationHelperAwaiter, AnimationHelperAwaiter];
}> => {
  const OnAnimated = onElementAnimated(getAnimatedElements, getAnimationsOptions);
  return useDomAnimationHelper({
    active: [OnImmediate, OnAnimated],
    ready: OnAnimationFrame,
    done: [OnAnimated, OnImmediate],
  });
};
